import { useState } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { suitFaqs } from '../../../mocks/trajesMedida';

export default function FAQSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section ref={ref} className="w-full bg-white py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-2xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Preguntas Frecuentes
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Todo lo que necesitas
            <span className="italic text-brand-gray-300"> saber</span>
          </h2>
        </div>

        <div className="mt-14 max-w-3xl mx-auto space-y-4">
          {suitFaqs.map((faq, index) => (
            <div
              key={index}
              className="bg-brand-gray-50 rounded-2xl overflow-hidden border border-transparent hover:border-brand-gray-100 transition-colors duration-300"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-start justify-between p-6 md:p-7 text-left"
              >
                <span className="font-serif text-brand-black text-base md:text-lg font-medium pr-4">
                  {faq.question}
                </span>
                <i className={`ri-add-line text-brand-gray-400 text-xl flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} />
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-6 md:px-7 pb-6 md:pb-7 font-sans text-brand-gray-500 text-[15px] leading-[1.8]">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}